<template>
  <div class="container">
  <div v-show="loading" class="loading">
      <i  class="fa fa-3x fa-spinner fa-spin"></i>
    </div>  
    <div class="row">
      <div class="col-md-12">
        <div class="widget-wrap">
          <div class="widget-container margin-top-0">
            <div class="widget-content">
              <div class="row">
                <div class="col-md-12">
                  <form class="j-forms" novalidate>
                    <div class="form-content">
                      <div class="w-section-header">
                        <h3>Reset Password</h3>
                      </div>
                      <div v-if="recoverErr" class="row">
                        <div class="col-sm-6 col-sm-offset-3">
                          <div class="error-message">
                            <p>{{ recoverErr }}</p>
                          </div>
                        </div>
                      </div> 

                      <div v-if="success" class="row">
                        <div class="col-sm-6 col-sm-offset-3 unit">
                          <div class="success-message">
                            <i class="fa fa-check"></i>
                            <strong>Mail sent successfully!</strong>
                          </div>
                        </div>                        
                      </div>
                      <div v-if="success" class="row">
                        <a href="/login"><button type="button" class="btn btn-primary">OK</button></a> 
                      </div>                     
                      <div v-if="!success" class="row">
                        <div class="col-sm-12">
                          <p>Please follow the instructions in the email to reset your password.</p>
                        </div>
                        <div class="col-sm-6 col-sm-offset-3 unit">
                            <div class="input">
                              <input v-model="email" @change="enableButton()" @click="enableButton()" v-validate="'required|email'" class="form-control" type="email" placeholder="Email" name="email" id="email" autofocus="autofocus">
                              <span v-show="errors.has('email')" class="error-view">{{ errors.first('email') }}</span>
                            </div>
                         
                            <br>
                            <div class="input">
                              <input v-model="reset_code" @change="enableButton()" @click="enableButton()" v-validate="'required'" class="form-control" type="text" placeholder="Reset Code" name="reset_code" id="reset_code" autofocus="autofocus">
                              <span v-show="errors.has('reset_code')" class="error-view">{{ errors.first('reset_code') }}</span>
                            </div>
                        </div>
                        <div class="col-sm-12">
                          <p>Choose a New Password</p>
                        </div>
                        <div class="col-sm-6 col-sm-offset-3 unit">
                            <div class="input">
                              <input v-model="password" v-validate="'required|verify_password'" @change="enableButton()" @click="enableButton()" class="form-control" type="password" placeholder="Password" name="password" id="password" autofocus="autofocus" ref="password">
                              <span v-show="errors.has('password')" class="error-view">{{ errors.first('password') }}</span>
                            </div>
                         
                            <br>
                            <div class="input">
                              <input v-model="password_again" v-validate="'required|confirmed:password'" class="form-control" type="password" @change="enableButton()" @click="enableButton()" placeholder="Password (Again)" name="password_again" id="password_again" autofocus="autofocus">
                              <span v-show="errors.has('password_again')" class="error-view">{{ errors.first('password_again') }}</span>
                            </div>
                        </div>
                      </div>
                   
                      <div v-if="!success" class="row">
                        <button type="button" class="btn btn-primary" @click="recoverPass()" v-bind:disabled="disableButton">Reset Password</button>
                        
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import auth from '../auth'
  import VeeValidate from 'vee-validate'
  VeeValidate.Validator.extend('verify_password', {
      getMessage: field => 'The password must be at least 8 characters and must contain an uppercase letter, a lowercase letter, a number, and one special character (E.g. , . _ & ? etc)',
      validate: value => {
          var strongRegex = /^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)(?=\S*([^\w\s]|[_]))\S{8,}$/g;
          return strongRegex.test(value);
      }
  })
  export default {
    data () {
      return {
        recoverErr: '',
        email: this.$route.query.e,
        reset_code: this.$route.query.code,
        password: '',
        password_again: '',
        success: false,
        disableButton: true,
        loading: false
      }
    },
    methods:{
      recoverPass() {
        this.$validator.validateAll()
        if (this.$validator.errors.items.length == 0){
          var data = {
            email: this.email,
            code: this.reset_code,
            password: this.password,
            password_confirm: this.password_again
          }
          auth.resetPass(this, data)
        }
      },
      enableButton(){
        this.$validator.validateAll()
        if (this.$validator.errors.items.length == 0){        
          this.disableButton = false
        }else{
          this.disableButton = true
        }
      },
    },
    created(){
      VeeValidate.Validator.extend('verify_password', {
          getMessage: field => 'The password must be at least 8 characters and must contain an uppercase letter, a lowercase letter, a number, and one special character (E.g. , . _ & ? etc)',
          validate: value => {
            var strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^\w\s])(?=.{8,})/g;
            return strongRegex.test(value);
          }
      }) 

      const dictionary = {
        en: {
          attributes: {
            first_name: 'First Name',
            last_name: 'Last Name'
          }
        }
      };

      VeeValidate.Validator.localize(dictionary);
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Reset.vue